import React, { useState, useRef, useCallback, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from "react-bootstrap";

import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import UploadFileIcon from '@mui/icons-material/UploadFile';

// const topics = [
//   { id: 1, name: "รายการที่ 1", image: "assets/aaa.png" },
//   { id: 2, name: "รายการที่ 2", image: "assets/back_left.png" },
//   { id: 3, name: "รายการที่ 3", image: "assets/back_right.png" },
//   { id: 4, name: "รายการที่ 4", image: "assets/back.png" },
//   { id: 5, name: "รายการที่ 5", image: "assets/engine.png" },
//   { id: 6, name: "รายการที่ 6", image: "assets/front_console.png" },
//   { id: 7, name: "รายการที่ 7", image: "assets/front_left.png" },
//   { id: 8, name: "รายการที่ 8", image: "assets/front_right.png" },
//   { id: 9, name: "รายการที่ 9", image: "assets/front.png" },
// ];

function CameraComponent(props) {
  const [capturedImages, setCapturedImages] = useState(Array(9).fill(null));
  const [addedImages, setAddedImages] = useState([]);
  const [facingMode, setFacingMode] = useState("environment");
  const [activeTopic, setActiveTopic] = useState(null);
  const [viewImage, setViewImage] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [cameraVisible, setCameraVisible] = useState(false);
  const [uploadAble, setUploadAble] = useState(false);  // true == can upload file

  const [axis1, setAxis1] = useState(window.innerWidth);
  const [axis2, setAxis2] = useState(window.innerHeight);
  const [windowWidth, setWindowWidth] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);
  // const [direction, setDirection] = useState('Y');  // Y: vertical / X: horizontal

  const [layoutScale, setLayoutScale] = useState(0);
  const [layoutPaddingLR, setLayoutPaddingLR] = useState(0);

  const [pendingImage, setPendingImage] = useState(null);
  const [pendingTopic, setPendingTopic] = useState(null);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  const startCamera = useCallback(() => {
    const constraints = {
      video: {
        // width: { ideal: 1920 },
        // height: { ideal: 1080 },
        width: { ideal: 1400 },
        height: { ideal: 933 },
        facingMode,
      },
      audio: false,
    };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        streamRef.current = stream;
        if (videoRef.current) {
            videoRef.current.srcObject = stream;
            videoRef.current.onloadedmetadata = () => {
            videoRef.current.play();
              // console.log(
              //     "Camera resolution:",
              //     videoRef.current.videoWidth,
              //     videoRef.current.videoHeight
              // );
            };
        }
        setCameraVisible(true);
      })
      .catch((err) => {
        console.error("Camera error:", err);
        setCameraVisible(false);
      });
  }, [facingMode]);

  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
  };

  const capture = () => {
    if (!videoRef.current || !canvasRef.current) return;

    // ////// ย้ายไปดักที่ปุ่ม //////
    // if(props && props.displayFormat == 'A'){  // A ถ่ายรูปรอบคัน : cannot capture with vertical layout
    //   if(window.innerWidth < window.innerHeight){
    //     alert("กรุณาหมุนหน้าจอ เพื่อถ่ายรูป");
    //     return;
    //   }
    // }

    const video = videoRef.current;
    const canvas = canvasRef.current;
    // canvas.width = video.videoWidth;
    // canvas.height = video.videoHeight;
    // console.log("video.width, video.height", video.videoWidth, video.videoHeight);
    // console.log("canvas.width, canvas.height", canvas.width, canvas.height);
    // console.log("window.innerWidth, window.innerHeight", window.innerWidth, window.innerHeight);
    //   var ww = video.videoWidth / window.innerWidth ;
    //   var hh = video.videoHeight / window.innerHeight ;
    //   console.log("ww hh",ww,hh);

    const maxWidth = 1400;
    const maxHeight = 933;
    let scale = Math.min(maxWidth / video.videoWidth, maxHeight / video.videoHeight);
    // console.log("scale",scale);
    const targetWidth = video.videoWidth * scale;
    const targetHeight = video.videoHeight * scale;
    // console.log("video.videoWidth",video.videoWidth,"video.videoHeight",video.videoHeight);
    canvas.width = targetWidth;
    canvas.height = targetHeight;

    const ctx = canvas.getContext("2d");
    // ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    ctx.drawImage(video, 0, 0, targetWidth, targetHeight);
    // const imageData = canvas.toDataURL("image/png");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    // console.log("canvas.width, canvas.height", canvas.width, canvas.height);
    // console.log("targetWidth, targetHeight", targetWidth, targetHeight);

    // if(imageData){
    //   if (activeTopic !== null) {
    //     console.log("capturedImages",capturedImages);
    //     setCapturedImages((prev) => {
    //       const newImages = [...prev];
    //       newImages[activeTopic.id - 1] = imageData;
    //           console.log("newImages",newImages);
    //           if(props.onCapture){
    //             props.onCapture(newImages);
    //           }
    //       return newImages;
    //     });
    //   } else if (isAddingNew) {
    //     setAddedImages((prev) => [...prev, imageData]);
    //   }
    //   // console.log("imageData",imageData);
    // }


    // บันทึกเป็น JPEG คุณภาพ 90%
    const imageData = canvas.toDataURL("image/jpeg", 0.9);

    setPendingImage(imageData);
    setPendingTopic(activeTopic);

    closeCamera();
  };

  const closeCamera = () => {
    stopCamera();
    setCameraVisible(false);
    setActiveTopic(null);
    setIsAddingNew(false);
  };

  const switchCamera = () => {
    setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
  };

  const calLayout = () => {
    // console.log("==== cal Layout ====");
    const videoWidth = 1400;
    const videoHeight = 933;
                var ww = videoWidth / window.innerWidth ;
                var hh = videoHeight / window.innerHeight ;
                // console.log("ww hh",ww,hh);
                // console.log("width", videoWidth , window.innerWidth, ww);
                // console.log("height", videoHeight , window.innerHeight, hh);
                let scale = Math.min(window.innerWidth / videoWidth, window.innerHeight / videoHeight);
                setLayoutScale(scale);
                // console.log("window.innerWidth / videoWidth",window.innerWidth / videoWidth);
                // console.log("window.innerHeight / videoHeight",window.innerHeight / videoHeight);
                // console.log("scale",scale);
                if((window.innerWidth / videoWidth)>(window.innerHeight / videoHeight)){
                  // console.log("if");
                  var newVideoWidth = videoWidth * scale;
                  // console.log("newVideoWidth",newVideoWidth);
                  var marginLR = (window.innerWidth - newVideoWidth)/2;
                  setLayoutPaddingLR(marginLR);
                }else{
                  // console.log("else");  // น่าจะไม่มีปัญหา ยังไม่ทำอะไรไปก่อน
                  var newVideoHeight = videoHeight * scale;
                  // console.log("newVideoHeight",newVideoHeight);
                }
  };

  useEffect(() => {
    // console.log("width",window.innerWidth);
    // if(window.innerWidth>800){  // เช็คแบบง่ายๆ ไม่งั้นต้องไป 'npm install react-device-detect --save'
    //   setVideoConstraints(FACING_MODE_USER);
    // }
    // console.log("props",props);
    // console.log("previousData",props.previousData);
    // setActiveTopic({ id: 1, displayFormat: 'B', name: 'ถ่ายรูปเลขไมล์' });
    // console.log("activeTopic",activeTopic);
    // setViewImage({ src: capturedImages[0], 0 });
    // console.log("viewImage",viewImage);
    // const imageSrc = webcamRef.current.getScreenshot();
    // console.log("webcamRef.current.getScreenshot",imageSrc);
      if(props.previousData){
        setCapturedImages(props.previousData);
      }
      // console.log("capturedImages",capturedImages);
        if(props.uploadAble){
          setUploadAble(props.uploadAble);
          // console.log("uploadAble", uploadAble);
        }




      calLayout();

        // console.log('base sized: ', window.innerWidth, 'x', window.innerHeight,"displayFormat",props.displayFormat);
        setWindowWidth(window.innerWidth);
        setWindowHeight(window.innerHeight);
        function handleResize() {
          // console.log('resized to: ', window.innerWidth, 'x', window.innerHeight,"verzo3");

                calLayout();

          if(window.innerWidth >= window.innerHeight){ // แนวนอน horizontal
            // console.log("if Width > Height", window.innerWidth , window.innerHeight);
          //   setAxis1(1400);
          //   setAxis2(800);
            // setDirection('X');
          }else{  // แนวตั้ง vertical
            // console.log("else");
          //   setAxis1(800);
          //   setAxis2(1400);
            // setDirection('Y');
          }

          setAxis1(window.innerWidth);
          setAxis2(window.innerHeight);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);

  }, []);

  useEffect(() => {
    if (cameraVisible) {
      startCamera();
    } else {
      stopCamera();
    }
    return () => stopCamera();
  }, [cameraVisible, startCamera]);

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        if (activeTopic !== null) {
          setCapturedImages((prev) => {
            const newImages = [...prev];
            newImages[activeTopic.id - 1] = base64;
              if(props.onCapture){
                props.onCapture(newImages);
              }
            return newImages;
          });
        } else {
          setAddedImages((prev) => [...prev, base64]);
        }
        closeCamera();
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (index, isFromAddedList = false) => {
    if (isFromAddedList) {
      setAddedImages((prev) => prev.filter((_, i) => i !== index));
    } else {
      setCapturedImages((prev) => {
        const newImages = [...prev];
        newImages[index] = null;
        if(props.onRemoveImage){
          props.onRemoveImage(index, newImages);
        }
        return newImages;
      });
    }
    setViewImage(null);
  };

  const openCameraForTopic = (topic) => {
    setActiveTopic(topic);
    setIsAddingNew(false);
    setCameraVisible(true);
  };

  const openCameraForNewImage = () => {
    setActiveTopic(null);
    setIsAddingNew(true);
    setCameraVisible(true);
  };

  const uploadImageToAPI = async (base64Data) => {
    try {
      console.log("อัปโหลดสำเร็จ");
        // //// call api saveImage //// มันมีปัญหา เอาออกไปก่อน
        // if(props.onSaveImage){
        //   props.onSaveImage(base64Data);
        // }
      return true;
    } catch (err) {
      console.error("อัปโหลดล้มเหลว:", err);
      return false;
    }
  };

  const confirmUpload = async () => {
    if (!pendingImage) return;

    const ok = await uploadImageToAPI(pendingImage);
    if (!ok) return;

    if (pendingTopic !== null) {
      setCapturedImages((prev) => {
        const newImages = [...prev];
        newImages[pendingTopic.id - 1] = pendingImage;
          if(props.onCapture){
            props.onCapture(newImages);
          }
        return newImages;
      });
    } else {
      setAddedImages((prev) => [...prev, pendingImage]);
    }

    setPendingImage(null);
    setPendingTopic(null);
  };

  const cancelUpload = () => {
    setPendingImage(null);
    setPendingTopic(null);
  };

  const c = "col-";
  const cameraWidth = props?props.itemsCol?c+props.itemsCol:"col-4":'';

  const maxLayoutWidth = (100*layoutScale)+'%';
  const maxLayoutHeight = (100*layoutScale)+'%';
  let paddingLayout = '0 '+layoutPaddingLR+'px';
  if(window.innerWidth < window.innerHeight){
    paddingLayout = '0px';
  }
  // console.log("paddingLayout",paddingLayout);

  return (
    <div className="container text-center pt-3">
      {
        props?props.title?<h3>{props.title}</h3>
        :null:null
      }
      <div className="row">
        {props?props.items?props.items.map((topic, index) => (
          <div key={topic.id} className={cameraWidth + " p-2"}>
            <div className="border p-3 d-flex flex-column align-items-center">
              {capturedImages[index] ? (
                <img
                  src={capturedImages[index]}
                  alt={`Captured ${topic.name}`}
                  style={{ width: '100%', height: 'auto', cursor: 'pointer', objectFit: 'cover', maxWidth:'300px', maxHeight:'300px' }}
                  onClick={() => setViewImage({ src: capturedImages[index], index, isFromAddedList: false })}
                />
              ) : (
                <>
                  {
                    topic.displayFormat==='A'?<>
                    <span>{topic.name}</span>
                    <button type="button" className="btn btn-primary mt-2 text-nowrap" onClick={() => openCameraForTopic(topic)}>
                      +
                    </button></>
                    :null
                  }
                  {
                    topic.displayFormat==='B'?
                    <button type="button" className="btn btn-primary mt-2 text-nowrap" onClick={() => openCameraForTopic(topic)}>
                      <PhotoCameraIcon/> {topic.name}
                    </button>
                    :null
                  }
                </>
              )}
            </div>
          </div>
        ))
        :null:null
      }
      </div>

      {/* Camera Overlay */}
      {cameraVisible && (
        <div className="position-fixed top-0 start-0 w-100 h-100 bg-dark d-flex flex-column justify-content-center align-items-center" style={{ zIndex: 1050 }}>
         <video
            ref={videoRef}
            onLoadedMetadata={() => {
                const video = videoRef.current;
                // console.log("Video resolution:", video.videoWidth, "x", video.videoHeight);
            }}
            className="w-100 h-100 object-fit-contain"
            playsInline
            muted
            />
          {activeTopic?.image && (
            <img
                src={activeTopic.image}
                alt="Overlay"
                className="position-absolute top-0 start-0"
                style={{
                  pointerEvents: "none",
                  opacity: 0.6,
                  width: "100%",
                  height: "100%",
                  // maxWidth: maxLayoutWidth,
                  // maxHeight: maxLayoutHeight,
                  objectFit: "contain", // หรือ 'cover' ถ้าต้องการเต็มจอแต่ครอบ
                  padding: paddingLayout,
                }}
            />
            )}

          <canvas ref={canvasRef} style={{ display: "none" }} />
          <input type="file" accept="image/*" onChange={handleImageUpload} style={{ display: "none" }} id="upload-input" />

          {/* ถ้าหน้าจอแนวตั้ง แจ้งเตือนให้ rotate หน้าจอ */}
          {
            props && props.displayFormat==='A'?<>
            {window.innerWidth < window.innerHeight ? 
            <div className="position-absolute bottom-0 d-flex gap-3" style={{marginBottom:'60px', color:'black', backgroundColor: 'yellow', padding: '3px 6px'}} >'กรุณาหมุนหน้าจอ เพื่อถ่ายรูป'</div>
            : ''}
            </>
            :null
          }

          <div className="position-absolute bottom-0 mb-3 d-flex gap-3">
            {/*<button type="button" className="btn btn-secondary" onClick={switchCamera}><CameraswitchIcon /></button>*/}
            {uploadAble?
              <label htmlFor="upload-input" className="btn btn-secondary mb-0"><UploadFileIcon /></label>
            :null}
            {
              /* // A ถ่ายรูปรอบคัน : cannot capture with vertical layout */
              (props && props.displayFormat==='A' && window.innerWidth < window.innerHeight) ? 
              <button type="button" disabled ><NoPhotographyIcon /></button>
              : <button type="button" className="btn btn-primary" onClick={capture}><PhotoCameraIcon /></button>
            }
            <button type="button" className="btn btn-danger" onClick={closeCamera}>ปิด</button>
          </div>
        </div>
      )}

      {/* Modal แสดงภาพ */}
      <Modal show={!!viewImage} onHide={() => setViewImage(null)} centered>
        <Modal.Body className="text-center">
          {viewImage && <img src={viewImage.src} alt="Captured" className="w-100" />}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={() => removeImage(viewImage.index, viewImage.isFromAddedList)}>ลบ</button>
          <button type="button" className="btn btn-secondary" onClick={() => setViewImage(null)}>ปิด</button>
        </Modal.Footer>
      </Modal>


      {/* Modal ยืนยัน */}
      <Modal show={!!pendingImage} onHide={cancelUpload} centered>
        <Modal.Body className="text-center">
          {pendingImage && (
            <img src={pendingImage} alt="Preview" className="w-100 mb-3" />
          )}
          <p>คุณต้องการอัปโหลดรูปนี้หรือไม่?</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={cancelUpload}>ยกเลิก</button>
          <button className="btn btn-primary" onClick={confirmUpload}>ยืนยัน</button>
        </Modal.Footer>
      </Modal>


      {/* เพิ่มรูปภาพเพิ่มเติม */}
      {/* <button className="btn btn-secondary mt-3" onClick={openCameraForNewImage}>
        Add More
      </button> */}

      {/* รูปภาพที่เพิ่มแบบไม่มีหัวข้อ */}
      {/* <div className="mt-3">
        <h4>New Images</h4>
        <div className="row">
          {addedImages.map((img, index) => (
            <div key={index} className="col-4 p-2">
              <div className="border p-3 d-flex flex-column align-items-center">
                <img
                  src={img}
                  alt="Added Capture"
                  style={{ width: "100%", height: "auto", cursor: "pointer", objectFit: "cover" }}
                  onClick={() => setViewImage({ src: img, index, isFromAddedList: true })}
                />
              </div>
            </div>
          ))}
        </div>
      </div> */}

    </div>
  );
}

export default CameraComponent;
